"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PendingConnection = void 0;
const eventemitter3_1 = __importDefault(require("eventemitter3"));
const utils_1 = require("@streamr/utils");
const ConnectionManager_1 = require("./ConnectionManager");
const logger = new utils_1.Logger(module);
// PendingConnection is used as a reference to a connection that should be opened and handshaked to a given PeerDescriptor
// It does not hold a connection internally. The public method onHandshakedCompleted should be called once a connection for the 
// remotePeerDescriptor is opened and handshaked successfully.
// PendingConnections are created by the Connectors.
class PendingConnection extends eventemitter3_1.default {
    connectingAbortController = new AbortController();
    remotePeerDescriptor;
    replacedAsDuplicate = false;
    stopped = false;
    constructor(remotePeerDescriptor, timeout = 15 * 1000) {
        super();
        this.remotePeerDescriptor = remotePeerDescriptor;
        (0, utils_1.setAbortableTimeout)(() => {
            this.close(false);
        }, timeout, this.connectingAbortController.signal);
    }
    replaceAsDuplicate() {
        logger.trace((0, ConnectionManager_1.getNodeIdOrUnknownFromPeerDescriptor)(this.remotePeerDescriptor) + ' replaceAsDuplicate');
        this.replacedAsDuplicate = true;
    }
    onHandshakeCompleted(connection) {
        if (!this.replacedAsDuplicate) {
            this.emit('connected', this.remotePeerDescriptor, connection);
        }
    }
    close(graceful) {
        if (this.stopped) {
            return;
        }
        this.stopped = true;
        this.connectingAbortController.abort();
        if (!this.replacedAsDuplicate) {
            this.emit('disconnected', graceful);
        }
    }
    destroy() {
        if (this.stopped) {
            return;
        }
        this.stopped = true;
        this.connectingAbortController.abort();
        this.removeAllListeners();
    }
    getPeerDescriptor() {
        return this.remotePeerDescriptor;
    }
}
exports.PendingConnection = PendingConnection;
//# sourceMappingURL=PendingConnection.js.map